import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input"> & {
  variant?: 'default' | 'brand'
}>(
  ({ className, type, variant = 'default', ...props }, ref) => {
    const variantClasses = {
      default: "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      brand: "flex h-10 w-full rounded-xl border border-midnight/20 bg-white px-3 py-2 text-base text-midnight file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-midnight/60 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-holiday/70 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
    }
    
    return (
      <input
        type={type}
        className={cn(variantClasses[variant], className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
